<script>
  import Section from '../components/Section.svelte';
  import Panel from '../components/Panel.svelte';
  import Button from '../components/Button.svelte';
  import DataTable from '../components/DataTable.svelte';
  import Stepper from '../components/Stepper.svelte';
  import HelpDrawer from '../components/HelpDrawer.svelte';
  import { draft } from '../lib/partnerDraft.svelte.js';
  import { HELP } from '../lib/help.js';
  import { SELF } from '../../shared/config.js';

  const steps = ['Partner details', 'Granted to partner', 'Review'];
  const addInbound = () => draft.inboundContainers.push({ url: '', label: '' });
  const removeInbound = (i) => draft.inboundContainers.splice(i, 1);
</script>

<HelpDrawer {...HELP.partner} />

<h1 class="wf2-title wf2-title-level-1">Add sharing partner</h1>
<Stepper {steps} active={0} />

<Section title="Partner organisation">
  <Panel>
    <label class="wf2-field">Organisation name
      <input class="wf2-control" bind:value={draft.name} placeholder="e.g. Sala Apolo" />
    </label>
    <label class="wf2-field">Contact email
      <input class="wf2-control" type="email" bind:value={draft.email} placeholder="data@example.org" />
    </label>
    <label class="wf2-field">Partner WebID
      <input class="wf2-control mono" bind:value={draft.webId} placeholder="http://localhost:3000/…/profile/card#me" />
    </label>
    <p class="wf2-hint">
      A WebID is how an institution identifies itself across Pods. You share
      directly with theirs — they never get an account or a password on your
      side. See the “?”.
    </p>
  </Panel>
</Section>

<Section title="Granted by partner (optional)">
  <Panel>
    <p class="wf2-text">
      Add the exact container URLs the partner communicated to you. Knowing a URL
      does not grant access: the partner must separately grant your institutional
      WebID permission to read it.
    </p>
    <DataTable
      columns={['Our institutional WebID', 'Give this to the partner']}
      rows={[[SELF.webId, 'They grant this identity acl:Read']]}
    />
    {#each draft.inboundContainers as item, i}
      <div class="wf2-panel" style="margin-top:var(--space-3)">
        <label class="wf2-field">Container URL
          <input class="wf2-control mono" bind:value={item.url} placeholder="https://partner.example/pod/shared/ctl/" />
        </label>
        <label class="wf2-field">Label (optional)
          <input class="wf2-control" bind:value={item.label} placeholder="e.g. Diversity cubes" />
        </label>
        <Button variant="secondary" onclick={() => removeInbound(i)}>Remove</Button>
      </div>
    {/each}
    <Button variant="secondary" onclick={addInbound}>Add granted container</Button>
    <p class="wf2-hint">Leave this empty for an outbound-only partnership.</p>
  </Panel>
</Section>

<div class="wf2-row" style="gap:12px">
  <Button variant="primary" to="partner/access">Next: cubes to share</Button>
  <Button variant="secondary" to="overview">Cancel</Button>
</div>
